import { Currency, NbFormatter } from '@eih-netbroker/common';

export const useFormatter = (lang: string = 'hu-HU', currency: Currency = 'HUF' as Currency) => {
  return NbFormatter.getInstance(lang, currency);
};
